import {Injectable} from '@angular/core';
import {LastModifiedCardUtils} from '@application/helper/last-modified-card-utils';
import {
  ColDefBuilderFactoryService,
  GridOptionsBuilder,
  LinkIconRendererComponent,
  NoDataOverlayComponentParams,
  OverlayComponentParams,
  StringUtils,
  TranslateService
} from '@vdw/angular-component-library';
import {ColDef, ICellRendererParams} from 'ag-grid-community';

@Injectable()
export class FixedScheduleOverviewService {
  private readonly pageUrls = LastModifiedCardUtils.getPageUrls('fixedSchedule');

  public constructor(
    private readonly colDefBuilderFactoryService: ColDefBuilderFactoryService,
    private readonly translate: TranslateService
  ) {}

  public getColumnDefs(withLinkIcon: boolean = true): ColDef[] {
    let nameColDef = this.colDefBuilderFactoryService.getBuilder().withColIdAndField('name', true).withHeaderName('GENERAL.NAME').withComparator(StringUtils.stringComparator);

    if (withLinkIcon) {
      nameColDef = nameColDef.withCellRenderer(LinkIconRendererComponent, (params: ICellRendererParams) => {
        return {
          params,
          editPageUrl: this.pageUrls.edit
        };
      });
    }

    return [
      nameColDef.build(),
      this.colDefBuilderFactoryService
        .getBuilder()
        .withHeaderName('GENERAL.REPORT_DATA_SET_TEMPLATES.REPORT_ITEM_TEMPLATE_FIELD.ORDER_NAME')
        .withColId('productionOrderName')
        .withField('productionOrder.name')
        .build(),
      this.colDefBuilderFactoryService.getBuilder().withHeaderName('TEXTILE_DATA.CREEL.NUMBER_OF_DENTS').withColId('nrDentsForFabric').withField('dentsForFabric').build(),
      this.colDefBuilderFactoryService.getBuilder().withHeaderName('TEXTILE_DATA.FIXED_ORDER.SOLENOIDS_PER_PILE').withColId('solenoidsPerPile').withField('nrSolenoidsPerPile').build(),
      this.colDefBuilderFactoryService.getBuilder().withHeaderName('TEXTILE_DATA.MACHINE_QUALITY.REEDDENSITY').withColIdAndField('reedDensityInDentsPerMeter').build(),
      this.colDefBuilderFactoryService.getBuilder().withHeaderName('MACHINE.DETAILS.NR_CREEL_POSITIONS').withColId('amountOfCreelPositions').withField('numberOfCreelPositions').build()
    ];
  }

  public getDefaultGridOptionsBuilder(builder: GridOptionsBuilder): GridOptionsBuilder {
    return builder
      .withLoadingOverlay({
        scale: 0.7
      } as OverlayComponentParams)
      .withNoRowsOverlay({
        scale: 0.7,
        titleParam: this.translate.instant('TEXTILE_DATA.FIXED_ORDER.FIXED_ORDER', {count: 1}),
        hideDescription: true
      } as NoDataOverlayComponentParams);
  }
}
